import styled from 'styled-components'
import { Button } from 'antd'

export const AntButton = styled(Button)`
  padding: 0.5rem;
  height: auto !important;
  min-width: 20rem;
  font-size: 1.5rem;
  font-weight: 400;
  margin-top: 30px;
  border-radius: 5px;
  background-color: ${props => props.theme.PRIMARY_TEXT_COLOR} !important;
  border: 1px ${props => props.theme.OFI_PURPLE} !important;

  &:hover {
    box-shadow: 0 0 0 1px ${props => props.theme.OFI_PURPLE} !important;
  }

  &:focus {
    box-shadow: 0 0 0 1px ${props => props.theme.OFI_PURPLE} !important;
  }
`
